import type Module from 'mini-common-schema/lib/schema/Module';
import { lazyGetCalendarBootstrapOptions } from 'mini-calendar-bootstrap-config';
import { lazyGetMailBootstrapOptions } from 'mini-mail-bootstrap-config';
import { lazyGetPeopleBootstrapOptions } from 'mini-people-bootstrap-config';
import { lazyGetToDoBootstrapOptions } from 'mini-todo-bootstrap-config';
import type { BootstrapOptions } from 'mini-bootstrap';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import type { LazyAction, LazyBootModule } from 'owa-bundling-light';

export interface StartLazyConfig {
    options: LazyAction<
        (sessionPromise: Promise<SessionData | undefined>) => Promise<BootstrapOptions>,
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
         * See aka.ms/mini-lint-errors
         *	> Unexpected any. Specify a different type. */
        LazyBootModule<any>
    >;
}

type ModuleConfigMap = {
    [P in Module]?: StartLazyConfig;
};

export const moduleToConfigMap: ModuleConfigMap = {
    [0]: {
        options: lazyGetMailBootstrapOptions,
    },
    [1]: {
        options: lazyGetCalendarBootstrapOptions,
    },
    [2]: {
        options: lazyGetPeopleBootstrapOptions,
    },
    [10]: {
        options: lazyGetToDoBootstrapOptions,
    },
};
